import React from "react";
import { Grid } from "../../../UI/Grid";
import { Table } from "../../../UI/Table";
import { TableRow } from "../../../UI/TableRow";
import { TableCell } from "../../../UI/TableCell";
import { TableHead } from "../../../UI/TableHead";
import { Typography } from "../../../UI/Typography";
import { PortfolioLifestyleTemplate, PortfolioTemplates } from "../../../services/PortfolioApi";
import { TemplateCreationButton } from "../TemplateCreationButton";
import { useHistory } from "react-router";
import { PORTFOLIO_LIFESTYLE_TEMPLATE_DETAILED } from "../../../routes/super_admin/portfolio/PortfolioTemplateDetails";
import { StyledTableRow } from '../../..//routes/super_admin/portfolio/sharedElements';

interface TemplateDisplayProps {
  canCreate: boolean;
  templates: PortfolioTemplates;
  portfolioId: string;
}

export const TemplateDisplay: React.FC<TemplateDisplayProps> = ({ canCreate, templates, portfolioId }) => {
  const { push } = useHistory();

  return (
    <Grid container pb={2} pt={2} xs>
      <TemplateDisplayGroup canCreate={canCreate} title={"Lifestyle Templates"} portfolioId={portfolioId} items={templates.lifestyleTemplates}
        onTemplateClick={(templateId: number) => {
          push(PORTFOLIO_LIFESTYLE_TEMPLATE_DETAILED.replace(":portfolioId", portfolioId).replace(":templateId", String(templateId)));
        }}
        onTemplateAdd={() => { }}
      />
      <TemplateDisplayGroup canCreate={canCreate} title={"Majors Templates"} portfolioId={portfolioId} items={[]} onTemplateClick={() => { }} onTemplateAdd={() => { }} />
      <TemplateDisplayGroup canCreate={canCreate} title={"User Notifications Templates"} portfolioId={portfolioId} items={[]} onTemplateClick={() => { }} onTemplateAdd={() => { }} />
    </Grid>
  );
};

interface TemplateDisplayGroupProps {
  canCreate: boolean;
  title: string;
  portfolioId: string;
  items: PortfolioLifestyleTemplate[]
  onTemplateClick: (templateId: number) => void;
  onTemplateAdd: (template: PortfolioLifestyleTemplate) => void;
}

const TemplateDisplayGroup: React.FC<TemplateDisplayGroupProps> = ({ canCreate, title, portfolioId, items, onTemplateClick, onTemplateAdd }) => {
  return (
    <Grid item xs={12} paddingTop={2}>
      <Grid container>
        <Grid item xs>
          <Typography>
            {title}
          </Typography>
        </Grid>
        <Grid item>
          {canCreate && <TemplateCreationButton portfolioId={portfolioId} onTemplateAdd={onTemplateAdd} />}
        </Grid>
      </Grid>
      <TemplateDisplayTable onTemplateClick={onTemplateClick} templates={items} />
    </Grid>
  );
};

interface TemplateDisplayTableProps {
  templates: PortfolioLifestyleTemplate[];
  onTemplateClick: (templateId: number) => void;
}

const TemplateDisplayTable: React.FC<TemplateDisplayTableProps> = ({ templates, onTemplateClick }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Matching Communities</TableCell>
        </TableRow>
      </TableHead>
      {templates.map(template => <TemplateDisplayTableRow onTemplateClick={onTemplateClick} key={template.name} name={template.name} count={template.assignedCount} templateId={template.id} />)}
    </Table>
  );
};

interface TemplateDisplayTableRowProps {
  name: string;
  count: number;
  templateId: number;
  onTemplateClick: (templateId: number) => void;
}

const TemplateDisplayTableRow: React.FC<TemplateDisplayTableRowProps> = ({ name, count, onTemplateClick, templateId }) => {
  return (
    <StyledTableRow onClick={() => onTemplateClick(templateId)}>
      <TableCell>{name}</TableCell>
      <TableCell>{count}</TableCell>
    </StyledTableRow>
  );
};

